import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 如果这里报错,找不到文件,就去node_modules文件夹中查看具体位置在进行引入
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/vue-awesome-swiper'  
// css同理
import 'swiper/css/swiper.min.css'  
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue
 
import { WOW } from 'wowjs';
import animated from 'wowjs/css/libs/animate.css';
//这里需要将样式用起来，
Vue.use(animated);
//创建全局实例
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // 需要执行动画的元素的 class
  animateClass: 'animated', //animation.css 动画的 class
  offset: 0, // 距离可视区域多少开始执行动画
  mobile: true, // 是否在移动设备上执行动画
  live: false, // 异步加载的内容是否有效
});

// 屏蔽错误信息
Vue.config.errorHandler = (err) => {
};
// 屏蔽警告信息
Vue.config.warnHandler = (message) => null

new Vue({
  router,
  store,
  render: h => h(App),
  errorCaptured(e){  //加上这个则vue中不会再报错 
    return false; 
  }
}).$mount('#app')
